export const ENV = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'DEV'
export const LOCALE = process.env.LOCALE || 'es-CO'

export const concourseId = {
  'es-CO': {
    DEV: 609,
    PDN: 742,
  },
  'es-CL': {
    DEV: 610,
    PDN: 743,
  },
  'es-PE': {
    DEV: 611,
    PDN: 744,
  },
  'es-PY': {
    DEV: 612,
    PDN: 745,
  },
}[LOCALE][ENV]

export const costActivity = 0
export const forumId = {
  'es-CO': {
    DEV: 63,
    PDN: 66, //51
  },
  'es-CL': {
    DEV: 63,
    PDN: 67, //51
  },
  'es-PE': {
    DEV: 63,
    PDN: 68, //51
  },
  'es-PY': {
    DEV: 63,
    PDN: 69, //51
  },
}[LOCALE][ENV]
export const LOCALE_AT = {
  COLOMBIA: LOCALE === 'es-CO',
  ARGENTINA: LOCALE === 'es-AR',

  BOLIVIA: LOCALE === 'es-BO',

  ECUADOR: LOCALE === 'es-EC',

  PERU: LOCALE === 'es-PE',

  CHILE: LOCALE === 'es-CL',
  URUGUAY: LOCALE === 'es-UY',

  DOMINICANA: LOCALE === 'es-DO',
  PUERTO_RICO: LOCALE === 'es-PR',
  PARAGUAY: LOCALE === 'es-PY',
}
